<template>
  <div class="container" align="center">
    <div v-if="access.read">
      <v-card
        v-if="!loading"
        elevation="0"
        class="ma-8 px-10 py-8 d-flex flex-column justify-start main-container"
      >
        <v-row>
          <v-col cols="1" align="center" class="mx-4">
            <v-btn outlined @click="setToday"> Today </v-btn>
          </v-col>
          <v-col cols="1" align="center">
            <v-btn
              text
              small
              color="grey darken-2"
              @click="$refs.calendar.prev()"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col text cols="1" align="center">
            <v-btn
              text
              small
              color="grey darken-2"
              @click="$refs.calendar.next()"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-col>
          <v-col>
            <v-toolbar-title v-if="$refs.calendar">
              <p class="font-weight-bold">{{ $refs.calendar.title }}</p>
            </v-toolbar-title>
          </v-col>
          <v-col cols="3">
            <!-- <v-select
              v-model="calendarType"
              :items="calendarTypes"
              dense
              outlined
              hide-details
              label="View"
            ></v-select> -->
          </v-col>
        </v-row>
        <v-sheet :height="sheetHeight">
          <v-calendar
            ref="calendar"
            v-model="focus"
            :type="calendarType"
            :events="events"
            :event-color="getColor"
            @change="change"
            @click:event="eventClick"
            @click:more="eventMoreClick"
          ></v-calendar>
        </v-sheet>
        <v-dialog v-model="eventDialog" width="400" align="center">
          <v-card>
            <v-card-title class="pb-0">
              <v-row>
                <v-col cols="1" class="ml-2 mr-4 py-0"></v-col>
                <v-col class="pb-1 pl-0">
                  <p class="font-weight-bold cardTitle">
                    {{ clickedEvent.name }}
                  </p>
                </v-col>
              </v-row>
            </v-card-title>
            <v-card-text>
              <v-row class="mt-1">
                <v-col cols="1" class="ml-2 mr-4 py-0">
                  <v-row align="center">
                    <v-icon medium>mdi-account-circle</v-icon>
                  </v-row>
                </v-col>
                <v-col class="py-0">
                  <v-row>
                    <p class="font-weight-bold subtitle-2">
                      <a @click="redirectBed">{{ clickedEvent.tenant }}</a>
                    </p>
                  </v-row>
                  <v-row>
                    <p class="caption">
                      Unit:
                      <span class="font-weight-bold">{{
                        clickedEvent.bedName
                      }}</span>
                    </p>
                  </v-row>
                  <v-row>
                    <p class="caption">
                      Alias:
                      <span class="font-weight-bold">{{
                        clickedEvent.alias
                      }}</span>
                    </p>
                  </v-row>
                </v-col>
              </v-row>
              <div v-if="clickedEvent.description">
                <!-- Complaint Event -->
                <v-row class="mt-3">
                  <v-col cols="1" class="ml-2 mr-4 py-0">
                    <v-row align="center">
                      <v-icon>mdi-exclamation-thick</v-icon>
                    </v-row>
                  </v-col>
                  <v-col class="py-0">
                    <v-row>
                      <p class="font-weight-bold subtitle-2">
                        {{ clickedEvent.title }}
                      </p>
                    </v-row>
                    <v-row>
                      <p class="caption">
                        Status:
                        <span class="font-weight-bold">{{
                          capitalize(clickedEvent.status)
                        }}</span>
                      </p>
                    </v-row>
                    <v-row>
                      <p class="caption">
                        Due Date:
                        <span class="font-weight-bold">{{
                          clickedEvent.dueDate
                        }}</span>
                      </p>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="1" class="ml-2 mr-4 py-0">
                    <v-row align="center">
                      <v-icon>mdi-text</v-icon>
                    </v-row>
                  </v-col>
                  <v-col class="py-0">
                    <v-row>
                      <p class="font-weight-bold subtitle-2">Description</p>
                    </v-row>
                    <v-row>
                      <p class="caption">{{ clickedEvent.description }}</p>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <div v-else-if="clickedEvent.total">
                <!-- Payment Event -->
                <v-row class="mt-3">
                  <v-col cols="1" class="ml-2 mr-4 py-0">
                    <v-row align="center">
                      <v-icon>mdi-calendar-month-outline</v-icon>
                    </v-row>
                  </v-col>
                  <v-col class="py-0">
                    <v-row>
                      <p class="font-weight-bold subtitle-2">Dates</p>
                    </v-row>
                    <v-row>
                      <p class="caption">
                        Due Date:
                        <span class="font-weight-bold">{{
                          clickedEvent.dueDate
                        }}</span>
                      </p>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="1" class="ml-2 mr-4 py-0">
                    <v-row align="center">
                      <v-icon>mdi-cash-multiple</v-icon>
                    </v-row>
                  </v-col>
                  <v-col class="py-0">
                    <v-row>
                      <p class="font-weight-bold subtitle-2">Payment Info</p>
                    </v-row>
                    <v-row>
                      <p class="caption">
                        Total:
                        <span class="font-weight-bold">{{
                          formatCurrency(clickedEvent.total)
                        }}</span>
                      </p>
                    </v-row>
                    <v-row>
                      <p class="caption">
                        Amount paid:
                        <span class="font-weight-bold">{{
                          formatCurrency(clickedEvent.amountPaid)
                        }}</span>
                      </p>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
              <div v-else>
                <v-row class="mt-3">
                  <!-- Lease Event -->
                  <v-col cols="1" class="ml-2 mr-4 py-0">
                    <v-row align="center">
                      <v-icon>mdi-calendar-month-outline</v-icon>
                    </v-row>
                  </v-col>
                  <v-col class="py-0">
                    <v-row>
                      <p class="font-weight-bold subtitle-2">Contract Period</p>
                    </v-row>
                    <v-row>
                      <p class="caption">
                        <span class="font-weight-bold"
                          >{{ clickedEvent.moveInDate }} -
                          {{ clickedEvent.moveOutDate }}</span
                        >
                      </p>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row class="mt-3">
                  <v-col cols="1" class="ml-2 mr-4 py-0">
                    <v-row align="center">
                      <v-icon>mdi-cash-multiple</v-icon>
                    </v-row>
                  </v-col>
                  <v-col class="py-0">
                    <v-row>
                      <p class="font-weight-bold subtitle-2">Payment Info</p>
                    </v-row>
                    <v-row>
                      <p class="caption">
                        Rent Fee:
                        <span class="font-weight-bold">{{
                          formatCurrency(clickedEvent.rentFee)
                        }}</span>
                      </p>
                    </v-row>
                    <v-row>
                      <p class="caption">
                        Due Date:
                        <span class="font-weight-bold">{{
                          clickedEvent.paidUntilDate
                        }}</span>
                      </p>
                    </v-row>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <v-card-actions class="mt-0 pt-0">
              <v-spacer></v-spacer>
              <v-btn
                class="font-weight-bold mb-4 mr-4 pt-0 mt-0"
                color="primary"
                depressed
                @click="closeEventDialog"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog
          v-if="moreDialog"
          v-model="moreDialog"
          width="325"
          align="center"
        >
          <v-card>
            <v-card-title class="pb-0">
              <div class="flex">
                <v-row>
                  <v-col class="py-0 mt-0" align="center" justify="center">
                    <p class="weekdayTitle font-weight-bold">
                      {{ moreEvents.day }}
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- <v-col cols="1" class="ml-2 mr-4 py-0"></v-col> -->
                  <!-- <v-col class="pb-0" align="center" justify="center">
                  <p class="font-weight-bold cardTitle">{{moreEvents.name}}</p>
                </v-col> -->
                  <v-col class="pt-0 pb-1" align="center">
                    <h3 class="font-weight-bold">{{ moreEvents.date }}</h3>
                  </v-col>
                </v-row>
              </div>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col class="pt-2">
                  <v-row
                    v-for="(moreEvent, index) in moreEvents.events"
                    :key="`moreEvent-${index}`"
                    @click="eventClick({ event: moreEvent })"
                  >
                    <v-col cols="1" class="py-0 pl-0" align="center">
                      <v-icon :color="moreEvent.color">mdi-square-small</v-icon>
                    </v-col>
                    <v-col class="pl-2 py-0">
                      <a class="caption font-weight-bold">
                        {{ moreEvent && moreEvent.name }}
                      </a>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card>
      <v-skeleton-loader
        v-else
        ref="skeleton"
        type="date-picker"
        loading
        class="ma-8 px-10 py-8"
      ></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
import Hashids from 'hashids'
import { DATEPICKER, dayjs } from '../util/date'
const hashids = new Hashids()
export default {
  data() {
    return {
      focus: '',
      type: 'month',
      events: [],
      moreEvents: {},
      loading: false,
      eventDialog: false,
      moreDialog: false,
      clickedEvent: '',
      calendarType: 'month',
      sheetHeight: 450,
      days: ['SUN', 'MON', 'TUES', 'WED', 'THURS', 'FRI', 'SAT']
      // calendarTypes: [{text:'Month', value:'month'}],
    }
  },
  computed: {
    access() {
      return this.$root.$roleAccess('calendar').access
    },
    user() {
      return this.$store.getters['auth/getUser']
    }
  },
  methods: {
    async change(dates) {
      this.events = []

      const currentMonth = dates.start.month - 1 // January is 1 in 'dates'
      const currentYear = dates.start.year

      await this.$store.dispatch('units/fetchMonthEventsAction', {
        month: currentMonth,
        year: currentYear
      })

      const monthEvents = this.$store.getters['units/getMonthEvents']
      if (monthEvents) {
        monthEvents.paidUntilDate.forEach((lease) => {
          const name = `${lease.bed_details.bedName} Rent Due`
          const start = dayjs(lease.paidUntilDate).format(DATEPICKER)
          this.events.push({
            name: name,
            start: start,
            alias: (lease.alias_details && lease.alias_details.name) || '',
            color: 'grey',
            tenant: lease.tenant_details.username,
            bedName: lease.bed_details.bedName,
            moveInDate: dayjs(lease.moveInDate).format(`MMMM D, YYYY`),
            moveOutDate: dayjs(lease.moveOutDate).format(`MMMM D, YYYY`),
            paidUntilDate: dayjs(lease.paidUntilDate).format(`MMMM D, YYYY`),
            bedId: lease.bedId,
            rentFee: lease.rentFee
          })
        })

        monthEvents.moveInDate.forEach((lease) => {
          if (!lease.tenant_details) {
            return
          }

          const name = `${lease.bedName} Move In`
          const start = dayjs(lease.moveInDate).format(DATEPICKER)
          this.events.push({
            name: name,
            start: start,
            alias: (lease.alias_details && lease.alias_details.name) || '',
            color: 'green',
            tenant: lease.tenant_details.username,
            bedName: lease.bedName,
            moveInDate: dayjs(lease.moveInDate).format('MMMM D, YYYY'),
            moveOutDate: dayjs(lease.moveOutDate).format(`MMMM D, YYYY`),
            paidUntilDate: dayjs(lease.paidUntilDate).format(`MMMM D, YYYY`),
            bedId: lease.bedId,
            rentFee: lease.rentFee
          })
        })

        monthEvents.moveOutDate.forEach((lease) => {
          if (!lease.tenant_details) {
            return
          }

          const name = `${lease.bedName} Move Out`
          const start = dayjs(lease.moveOutDate).format(DATEPICKER)
          this.events.push({
            name: name,
            start: start,
            alias: (lease.alias_details && lease.alias_details.name) || '',
            color: 'purple',
            tenant: lease.tenant_details.username,
            bedName: lease.bedName,
            moveInDate: dayjs(lease.moveInDate).format(`MMMM D, YYYY`),
            moveOutDate: dayjs(lease.moveOutDate).format('MMMM D, YYYY'),
            paidUntilDate: dayjs(lease.paidUntilDate).format(`MMMM D, YYYY`),
            bedId: lease.bedId,
            rentFee: lease.rentFee
          })
        })

        monthEvents.complaints.forEach((complaint) => {
          const name = `${complaint.bed_details.bedName} Complaint`
          const start = dayjs(complaint.dueDate).format(DATEPICKER)
          this.events.push({
            name: name,
            start: start,
            alias:
              (complaint.alias_details && complaint.alias_details.name) || '',
            color: 'red darken-2',
            tenant: complaint.tenant_details.username,
            bedName: complaint.bed_details.bedName,
            status: complaint.status,
            description: complaint.description,
            title: complaint.complaintTitle,
            dueDate: dayjs(complaint.dueDate).format('MMMM D, YYYY')
          })
        })

        monthEvents.payments.forEach((payment) => {
          const unitName =
            payment.lease_details.bed_details &&
            payment.lease_details.bed_details.bedName
          const name = `${unitName} Payment Due`
          const start = dayjs(payment.dueDate).format(DATEPICKER)
          payment.unitName = unitName
          this.events.push({
            name: name,
            start: start,
            alias: (payment.alias_details && payment.alias_details.name) || '',
            color: 'indigo',
            tenant: payment.tenant_details.username,
            bedName: unitName,
            amountPaid: payment.amountPaid,
            total: payment.total,
            dueDate: dayjs(payment.dueDate).format(`MMMM D, YYYY`)
          })
        })
      }
    },
    getColor(event) {
      return event.color
    },
    eventClick(event) {
      this.eventDialog = true
      this.clickedEvent = event.event
    },
    eventMoreClick(moreInfo) {
      this.moreEvents = {}
      this.moreEvents.date = dayjs(moreInfo.date).format(`D`)
      this.moreEvents.day = this.days[moreInfo.weekday]
      const toDisplay = []
      this.events.forEach((calendarEvent) => {
        if (calendarEvent.start == moreInfo.date) {
          toDisplay.push(calendarEvent)
        }
      })
      this.moreEvents.events = toDisplay
      this.moreDialog = true
    },
    setToday() {
      this.focus = ''
    },
    redirectBed() {
      const bedId = this.clickedEvent.bedId
      const username = this.clickedEvent.tenant
      if (bedId != null) this.$router.push(`/bed/${hashids.encode(bedId)}`)
      else this.$router.push(`/user/${username}`)
    },
    formatCurrency(value) {
      if (value == null) return ''
      return parseFloat(value / 100).toLocaleString('en-PH', {
        style: 'currency',
        currency: 'PHP'
      })
    },
    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    closeEventDialog() {
      this.eventDialog = false
    },
    closeMoreDialog() {
      this.moreDialog = false
    }
  }
}
</script>

<style scoped>
.v-card {
  border-radius: 12px !important;
}
.container {
  height: 100vh;
}
#close {
  position: absolute;
  top: 10px;
  right: 12.5px;
}
.cardTitle {
  font-size: 0.95em;
}
.weekdayTitle {
  font-size: 0.5em;
}
</style>
